/* Coarse journey events only. Never collect form text or customer/cart properties. */
(() => {
  if (window.VunroCX) return;
  const events = new Set(['adviser_start','adviser_step','adviser_complete','adviser_recommendation_click','adviser_error','compatibility_start','compatibility_match','compatibility_no_match','bundle_select','cart_drawer_view']);
  const families = new Set(['a5','dseries','flexfit','maxfit','pawtrim','fiveinone','none','unknown']);
  function track(name, details = {}) {
    if (!events.has(name) || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;
    const data = { name, event_id: crypto.randomUUID() };
    if (Number.isInteger(details.step) && details.step >= 1 && details.step <= 4) data.step = details.step;
    if (families.has(details.family)) data.family = details.family;
    if (['validation','service','network'].includes(details.error)) data.error = details.error;
    if (['checkbox','variant','quantity'].includes(details.selection)) data.selection = details.selection;
    if (name === 'cart_drawer_view' && details.cart) {
      const cart = details.cart;
      if (!/^[A-Z]{3}$/.test(cart.currency) || !Number.isFinite(cart.total_price)) return;
      data.currency = cart.currency;
      data.value = cart.total_price / 100;
      data.items = cart.items.slice(0,200).map(item => ({
        item_id: /^[A-Za-z0-9_.\/-]{1,128}$/.test(item.sku || '') ? item.sku : String(item.variant_id || item.product_id),
        product_id: String(item.product_id), variant_id: String(item.variant_id),
        price: item.final_price / 100, quantity: item.quantity
      }));
    }
    try { Promise.resolve(publish.call(window.Shopify.analytics, 'vunro:cx', data)).catch(() => {}); return true; } catch (_) {}
  }
  window.VunroCX = { track };
  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    let open = drawer.classList.contains('active');
    new MutationObserver(() => {
      const next = drawer.classList.contains('active');
      if (next === open) return;
      open = next;
      if (!next || /\/cart\/?$/.test(location.pathname)) return;
      fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin'})
        .then(response => response.ok ? response.json() : Promise.reject())
        .then(cart => track('cart_drawer_view', {cart})).catch(() => {});
    }).observe(drawer, {attributes:true, attributeFilter:['class']});
  }
  let adviserStarted = false, compatibilityStarted = false;
  document.addEventListener('focusin', event => {
    if (!adviserStarted && event.target.closest('.vga-flow')) {
      adviserStarted = !!track('adviser_start');
    }
    if (!compatibilityStarted && event.target.matches('.vc-compat .search-wrap input')) {
      compatibilityStarted = !!track('compatibility_start');
    }
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-vga-result] a[href*="/products/"]')) track('adviser_recommendation_click');
    const box = event.target.closest('.lb-custom-checkbox, input[type="checkbox"]');
    if (event.isTrusted && box?.closest('.lb-bundle-products, lb-upsell-widget, lb-upsell')) track('bundle_select', {selection:'checkbox'});
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (!event.isTrusted || !input.closest('.lb-bundle-products, lb-upsell-widget, lb-upsell')) return;
    const selection = input.matches('select') ? 'variant' : input.matches('input[type="number"]') ? 'quantity' : null;
    if (selection) track('bundle_select', {selection});
  });
})();
